import React from "react";
import { FaChevronRight } from "react-icons/fa";

import { FaAngleLeft } from "react-icons/fa6";

import styles from "./Common.module.css";
import { useSelector } from "react-redux";
export default function Header({ title }) {
  const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div className={styles.headerContaier}>
      <div className={styles.overlay}></div>
      <h2 className={currentLocal.language === "العربيه" ? styles.arTitleHeader : styles.enTitleHeader}>{title}</h2>
      <p className={styles.titleContainer}>
        {currentLocal.general.home}{" "}
        {currentLocal.language === "English" ? <FaChevronRight /> : <FaAngleLeft />}{" "}
        {title}
      </p>
    </div>
  );
}
